import { useEffect } from "react";

const isIosWebView =
	!!window.ReactNativeWebView && !/android/i.test(navigator.userAgent);

export const useKeyboardScrollGuard = () => {
	useEffect(() => {
		const viewport = window.visualViewport;
		if (!isIosWebView || !viewport) {
			return;
		}

		const clampScroll = () => {
			const scrolled = document.scrollingElement?.scrollTop ?? window.scrollY;
			if (scrolled < 0 || window.scrollY < 0 || viewport.offsetTop < 0) {
				window.scrollTo({ top: 0, left: 0, behavior: "instant" });
			}
		};

		const handleViewportChange = () => {
			clampScroll();
			requestAnimationFrame(clampScroll);
		};

		viewport.addEventListener("resize", handleViewportChange);
		viewport.addEventListener("scroll", handleViewportChange);

		return () => {
			viewport.removeEventListener("resize", handleViewportChange);
			viewport.removeEventListener("scroll", handleViewportChange);
		};
	}, []);
};
